<template>
  <IconLucideCheckCheck />
</template>
